import i18n from '@/locales'

export const getStatusTableColumn = () => {
  return {
    field: 'status',
    title: i18n.t('inspection.columns.status'),
    slots: {
      default: ({ row }, h) => {
        if (row.status === 'success') {
          return [
            <status specifyStatus={{ class: 'status-success', text: i18n.t('inspection.report.status.success') }} />,
          ]
        } else if (row.status === 'error') {
          try {
            const results = JSON.parse(row.results || '{}')
            return [
              <div class="d-flex align-items-center">
                <status specifyStatus={{ class: 'status-danger', text: i18n.t('inspection.report.status.error') }} />
                <help-tooltip text={results.Details} class="ml-2" />
              </div>,
            ]
          } catch (error) {
            return [
              <div class="d-flex align-items-center">
                <status specifyStatus={{ class: 'status-danger', text: i18n.t('inspection.report.status.error') }} />
                <help-tooltip text={row.results} class="ml-2" />
              </div>,
            ]
          }
        }
        return [
          <div class="d-flex align-items-center">
            <a-icon class="mr-1" type="sync" spin />{ i18n.t('inspection.report.status.inspecting') }
          </div>,
        ]
      },
    },
  }
}
